// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { microphone16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-microphone': IconMicrophone;
    }
}

/**
 * The icon component for the 'microphone' icon
 */
export class IconMicrophone extends Icon {
    public constructor() {
        super(microphone16X16);
    }
}

registerIcon('icon-microphone', IconMicrophone);
export const iconMicrophoneTag = 'nimble-icon-microphone';
